import { Controller } from "@hotwired/stimulus"

// Toggle-Dropdown für gespeicherte Filter-Ansichten (Custom Views) +
// Save/Reset/Delete Aktionen via Backend-Endpoints.
export default class extends Controller {
  static targets = ["dropdown"]
  static values = { saveUrl: String, deleteUrl: String, baseUrl: String }

  connect() {
    this._onClickOutside = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    document.addEventListener("click", this._onClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.toggle("hidden")
    }
  }

  close() {
    if (this.hasDropdownTarget) this.dropdownTarget.classList.add("hidden")
  }

  async save(event) {
    event.preventDefault()
    event.stopPropagation()
    const name = prompt("Filter speichern als:")
    if (!name || !name.trim()) return

    const csrf =
      document.querySelector("meta[name='csrf-token']")?.content || ""
    const params = new URLSearchParams(window.location.search)
    const q = {}
    let scope = "all"
    for (const [key, value] of params.entries()) {
      const m = key.match(/^q\[(.+)\]$/)
      if (m) q[m[1]] = value
      else if (key === "scope") scope = value
    }

    try {
      const res = await fetch(this.saveUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf,
          Accept: "application/json"
        },
        body: JSON.stringify({ name: name.trim(), scope, q })
      })
      const data = await res.json()
      if (data.ok) {
        window.location.reload()
      } else {
        alert(data.error || "Fehler beim Speichern")
      }
    } catch {
      alert("Fehler beim Speichern")
    }
  }

  async remove(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!confirm("Ansicht löschen?")) return

    const id = event.currentTarget.dataset.presetId
    const csrf =
      document.querySelector("meta[name='csrf-token']")?.content || ""
    const url = this.deleteUrlValue.replace("__ID__", id)

    try {
      await fetch(url, {
        method: "DELETE",
        headers: { "X-CSRF-Token": csrf, Accept: "application/json" }
      })
      window.location.reload()
    } catch {
      alert("Fehler beim Löschen")
    }
  }

  reset(event) {
    event.preventDefault()
    const scope =
      new URLSearchParams(window.location.search).get("scope") || "all"
    const base = this.baseUrlValue || window.location.pathname
    window.location.assign(`${base}?scope=${scope}`)
  }
}
